export default {
  retrievedBuildings: (state, buildings) => {
    state.buildings = buildings;
  },

  setFilters: (state, filters) => {
    state.filters = filters;
  },

  setPaginationOptions: (state, paginationOptions) => {
    state.paginationOptions = paginationOptions;
  }
};
